"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInputContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledInputContainer = styled_components_1.default.div `
  margin: 30px 0 70px;
  padding-bottom: 100px;
`;
